import * as R from 'remeda'
import { useMemo } from 'react'
import { EventsMap, RoomEventsMap } from './types'
import { useAssembledBlocksAndMarkers } from './useAssembledBlocksAndMarkers'

interface Params {
  botId?: string
  events: RoomEventsMap
  guestId?: string
  initialEvents?: EventsMap
  roomId: string
}

const isInitial = (events: EventsMap | undefined, initialEvents: EventsMap | undefined) => {
  // If there's only an initial event we still want to show the optimistic ones because we use optimistic events only when doing the initial response
  // The first event is initial message from the server
  // The second event is what we sent to the server
  // The third event is some kind of response from the server (hopefully a successful one)
  return Boolean(initialEvents && Object.keys(events ?? {}).length <= 2)
}
const addInitialEvents = (events: EventsMap | undefined, initialEvents: EventsMap | undefined) => {
  if (isInitial(events, initialEvents)) {
    return initialEvents
  }
  return events
}

export const useRoomDataAndEffects = ({
  roomId,
  events,
  guestId,
  botId,
  initialEvents,
}: Params) => {
  const roomEvents = useMemo(
    () => addInitialEvents(events[roomId], initialEvents),
    [events, initialEvents, roomId]
  )

  const roomEventsArray = useAssembledBlocksAndMarkers(roomEvents, guestId, botId)

  const value = useMemo(() => {
    return {
      events: R.sortBy(roomEventsArray, event => event.timestamp),
      isInitial: isInitial(events[roomId], initialEvents),
    }
  }, [roomEventsArray, events, roomId, initialEvents])

  return value
}
